module.exports = __webpack_public_path__ + "img/img_throw_5@2x.a023b1ee.png";